module.exports = __webpack_public_path__ + "img/boxplot-tooltip.26169b91.png";